var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hmseries-and-footer"},[_c('hmserieseng'),_c('scfootereng')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }